import React, { Suspense, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
const Provenance = React.lazy(() => import("./Provenance"));
const SalesVolume = React.lazy(() => import("./SalesVolume"));


const NftTabs = () => {
  const [key, setKey] = useState("volume");

  const { id } = useParams()



  return (
    <Suspense fallback={<>Loading...</>}>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3 tab-btn-group"
      >
        <Tab
          eventKey="volume"
          title="Sales Volume"
          tabClassName="tab-btn"
        >
          <SalesVolume contactAddress={id} />
        </Tab>
        <Tab eventKey="provenance" title="Provenance" tabClassName="tab-btn">
          <Provenance />
        </Tab>
        <Tab eventKey="rankings" title="Rarity Rankings" tabClassName="tab-btn">

        </Tab>
        <Tab eventKey="checklists" title="Checklists" tabClassName="tab-btn">

        </Tab>
        <Tab eventKey="sales" title="Collection Rankings" tabClassName="tab-btn">

        </Tab>
      </Tabs >
    </Suspense>
  );
};

export default NftTabs;
